import clsx from 'clsx';
import { ReactNode } from 'react';

import { PixelGridBackground } from '@/components/common/pixel-grid-background';
import { useIsElementShown } from '@/shared/hooks/use-is-element-shown';
import { THomePageSectionProps } from '../state/types';
import { HomePageScrollIcon } from './home-page-scroll-icon';

interface HomePageSectionProps extends THomePageSectionProps {
  children: ReactNode;
  classes?: string;
}

export const HomePageSection = ({
  children,
  classes,
  id,
  scrollTo,
  withBackgroundGrid,
  wrapperClasses
}: HomePageSectionProps) => {
  const { isShown, ref } = useIsElementShown();

  return (
    <div
      id={id}
      className={clsx(
        'relative w-full min-h-screen justify-center bg-smoky-black overflow-hidden',
        isShown ? 'opacity-100 transition-all ease-in duration-1000' : 'opacity-0',
        wrapperClasses
      )}
    >
      {withBackgroundGrid && <PixelGridBackground />}

      <div className={clsx('relative z-10 w-full', classes)} ref={ref}>
        {children}
      </div>

      {scrollTo && (
        <div className="absolute bottom-0 inset-x-0 z-20 pointer-events-none">
          <HomePageScrollIcon scrollTo={scrollTo} />
        </div>
      )}
    </div>
  );
};
